module.exports = __webpack_public_path__ + "static/media/whatsapp.1def5ef9.png";